import { render, staticRenderFns } from "./TheNewsCol.vue?vue&type=template&id=4a33c234&scoped=true"
import script from "./TheNewsCol.vue?vue&type=script&lang=js"
export * from "./TheNewsCol.vue?vue&type=script&lang=js"
import style0 from "./TheNewsCol.vue?vue&type=style&index=0&id=4a33c234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a33c234",
  null
  
)

export default component.exports